import React from 'react';
import ReactModal from 'react-modal';
import { useHistory, useLocation } from 'react-router-dom';
import { Button as ReactButton } from '@a-ui/react';
import FilterIcon from '../../components/FilterIcon';
import Typography from '../../components/Typography';
import useDevice, { Device } from '../../hooks/device.hooks';
import { translate } from '../../i18n';
import NewsletterFilterModal from './NewsletterFilterModal';

interface NewsletterFilterProps {
  categories: string[];
}

const NewsletterFilter: React.FC<NewsletterFilterProps> = ({ categories = [] }) => {
  const [isOpen, setOpen] = React.useState(false);
  const device = useDevice();
  const { search } = useLocation();
  const params = React.useMemo(() => new URLSearchParams(search), [search]);
  const history = useHistory();

  const reset = () => {
    params.delete('categories[]');
    params.delete('sort');

    setOpen(false);
    history.push({ search: params.toString() });
  };

  const toggleFilter = () => {
    setOpen(!isOpen);
  };

  return (
    <div className="ckp-o-newsletter-filter">
      <div className="ckp-o-newsletter-filter__header">
        <Typography>{translate('newsletters.overview.description')}</Typography>
        <div
          className={`ckp-o-newsletter-filter_button ${
            device === Device.DESKTOP && 'a-button--transparent'
          }`}
        >
          <ReactButton emphasis="low" onClick={toggleFilter}>
            <FilterIcon inverse={device === Device.MOBILE} />
            {translate('newsletters.filter.cta')}
          </ReactButton>
        </div>
      </div>

      {isOpen && (
        <>
          {device === Device.DESKTOP && (
            <NewsletterFilterModal
              categories={categories}
              setVisible={setOpen}
              cancelLabel="newsletters.filter.reset"
              onCancel={reset}
            />
          )}
          {device === Device.MOBILE && (
            <ReactModal
              isOpen
              role="dialog"
              aria-modal="true"
              onAfterOpen={() => window.scroll(0, 0)}
              onRequestClose={toggleFilter}
              overlayClassName="ckp-o-newsletter-filter__modal__overlay"
              className="ckp-o-newsletter-filter__modal__wrapper"
            >
              <NewsletterFilterModal
                categories={categories}
                setVisible={setOpen}
                cancelLabel="common.button.cancel"
                onCancel={toggleFilter}
                showBackLink
              />
            </ReactModal>
          )}
        </>
      )}
    </div>
  );
};

export default NewsletterFilter;
